export default __webpack_public_path__ + "static/tree-planting-8b71dd0a0d0304e0ace8baa277211acc.webp";